export class IssuesFilterComponentsValues {
    postsaleIsChecked: boolean = null;
    presaleIsChecked: boolean;
    reviewIsChecked: boolean;
    pendingProcessingIsChecked: boolean;
    processedNoDateIsChecked: boolean;
    processedDateIsChecked: boolean;
    pendingMaterialIsChecked: boolean;
    repairedClosedIsChecked: boolean;
    notApplicableIsChecked: boolean;
    localizationSelectId: number;
    jobsSelectIds: number[];
    createDateFrom: string;
    createDateTo: string;
    appointmentDateFrom: string;
    appointmentDateTo: string;
    commonArea: number;
    portal: string;
    floor: string;
    door: string;
    csiteId: number;
    operatorId: number;
    state: string;
    idSelected: number;
    supplierPartnerAssignmentDateFrom: string;
    supplierPartnerAssignmentDateTo: string;
}
